import {useState} from 'react';
import {CaretLeftIcon} from '@phosphor-icons/react';
import {ConfirmModal} from '@/components/modals/confirm-modal';
import styles from '../style.module.css';

interface ChatHeaderProps {
    hasMessages: boolean;
    onClearMessages: () => void;
    onClose: () => void;
}

export function ChatHeader({
    hasMessages,
    onClearMessages,
    onClose,
}: ChatHeaderProps) {
    const [showClearConfirm, setShowClearConfirm] = useState(false);

    const handleClearConfirm = () => {
        onClearMessages();
        setShowClearConfirm(false);
    };

    return (
        <>
            <div className={styles.chatHeader}>
                {hasMessages && (
                    <button
                        onClick={() => setShowClearConfirm(true)}
                        className={styles.clearLink}
                    >
                        clear chat
                    </button>
                )}
                <button onClick={onClose} className={styles.hideButton}>
                    <CaretLeftIcon size={14} weight="bold" />
                    Hide Linda
                </button>
            </div>

            <ConfirmModal
                isOpen={showClearConfirm}
                title="Clear Chat"
                message="Are you sure you want to clear all messages?"
                confirmButtonText="Clear"
                onClose={() => setShowClearConfirm(false)}
                onConfirm={handleClearConfirm}
            />
        </>
    );
}
